import { Message } from "element-ui";
function initwebupload(
  name,
  value,
  backFun,
  percentageBackFun,
  backError,
  beforeFileQueued,
  params,
  types,
  sizeLimit
) {
  let acceptValue;
  const returnData = {};
  const FILE_SIZE_LIMIT = sizeLimit || 200;
  const acceptImageType = {
    title: "文件上传",
    extensions: "gif,jpg,jpeg,bmp,png",
    mimeTypes: ".gif,.jpg,.jpeg,.bmp,.png,"
  };
  const acceptZipType = {
    title: "Zip",
    extensions: "zip,rar",
    mimeTypes: ".zip,.rar" // 设置文件类型限制
  };
  const acceptMp4Type = {
    title: "Videos",
    mimeTypes: "video/mp4"
  };
  const accepPptType = {
    title: "ppt",
    extensions: "ppt,pptx,pdf",
    mimeTypes: ".ppt,.pptx,.pdf"
  };

  const accepRealitiType = {
    title: "Realiti",
    extensions: "wps,rtf,ppt,pptx,pps,ppsx,xls,xlsx,txt,md,rst,pdf,doc,docx",
    mimeTypes:
      ".wps,.rtf,.ppt,.pptx,.pps,.ppsx,.xls,.xlsx,.txt,.md,.rst,.pdf,.doc,.docx"
  };

  if (value === "images") {
    acceptValue = acceptImageType;
  } else if (value === "zip") {
    acceptValue = acceptZipType;
  } else if (value === "video") {
    acceptValue = acceptMp4Type;
  } else if (value === "ppt") {
    acceptValue = accepPptType;
  } else if (value === "Realiti") {
    acceptValue = accepRealitiType;
  } else {
    acceptValue = value || null;
  }
  // eslint-disable-next-line no-undef
  const uploader = WebUploader.create({
    // 选择文件的按钮
    pick: {
      id: `${name}`,
      multiple: false
    },
    // 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
    compress: false,
    // 是否开启大文件分片上传，默认为true
    chunked: true,
    // 分片上传线程数，默认为3，如果使用断点续传建议线程数改为1
    threads: 1,
    // 如果某个分片由于网络问题出错，允许自动重传多少次，默认为2
    chunkRetry: 2,
    // 每一片的大小，默认为10M
    chunkSize: 1024 * 1024 * 10,
    // 上传超时时间，默认为2分钟
    timeout: 15 * 60 * 1000,
    // 是否允许同一个文件重复上传，默认为false
    duplicate: true,
    // 非官方参数，文件大小超过该值则进行分片，默认为10M
    thresholdSize: 1024 * 1024 * 10,
    // 非官方参数，是否支持切换至阿里云，有特殊需求的项目可以开通此项，需要进行授权，默认为false
    uploadToThirdPartyStorage: false,
    // 非官方参数，是否开启秒传，默认为true，强烈建议开启。秒传关闭情况，阿里云分片上传默认无MD5
    checkMd5: true,
    withCredentials: false, // 携带Cookie
    // fileNumLimit: 1, //设置文件数量限制如果是一可能会影响文件再次上传
    fileSizeLimit: FILE_SIZE_LIMIT * 1024 * 1024, // 限制上传所有文件大小
    accept: {
      // 设置文件类型限制
      ...acceptValue
    }
  });
  uploader.on("beforeFileQueued", function (file) {
    return beforeFileQueued ? beforeFileQueued(file) : true;
  });
  // 文件被加入队列
  uploader.on("fileQueued", function (file) {
    // 捕捉获取文件时间
    if (file.name) {
      returnData.fileName = file.name;
      uploader.upload();
    }
  });
  // eslint-disable-next-line no-unused-vars
  uploader.on("md5Progress", function (percentage, file) {
    const data = {
      percentage: 100 * percentage - 1,
      name: uploader.options.pick
    };
    setTimeout(function () {
      percentageBackFun && percentageBackFun(data);
    }, 10);
  });
  // 上传成功
  uploader.on("uploadSuccess", function (file) {
    const data = {
      percentage: 100 * 1,
      name: uploader.options.pick
    };
    returnData.fileUrl = file.url;
    returnData.contextId = file.contextId;
    returnData.name = uploader.options.pick;
    params && (returnData.params = params);
    types && (returnData.types = types);
    backFun && backFun(returnData); // 异步操作返回数据
    percentageBackFun && percentageBackFun(data);
    // 文件上传后 文件清空，防止计算文件大小算上之前的文件大小，提示超出文本
    uploader.reset();
  });
  uploader.on("error", function (type) {
    if (type === "Q_EXCEED_SIZE_LIMIT") {
      Message({
        type: "error",
        message: `文件大小不能超过${FILE_SIZE_LIMIT}M`
      });
    } else if (type.indexOf("REQUEST_ERROR_MESSAGE") !== -1) {
      const msg = type.split("-")[1];
      Message({
        type: "error",
        message: msg
      });
      const data = {
        percentage: 100 * 1,
        name: uploader.options.pick
      };
      percentageBackFun && percentageBackFun(data);
    } else if (type === "Q_TYPE_DENIED") {
      Message({
        type: "error",
        message: `文件类型有误，请上传相应的文件类型：${acceptValue.mimeTypes.replace(
          /,/g,
          " 或 "
        )}`
      });
    } else {
      Message({
        type: "error",
        message: "上传出错！请检查后重新上传！"
      });
    }

    backError && backError();
    uploader.reset();
  });
}
export { initwebupload };
